import { IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { Subscription } from 'rxjs';
import { KeyValuePairArray } from '../../../models/KeyValuePair';
import { LoginResponse } from '../../../models/ss-api/responses/login.response';
import { GlobalServices } from '../../../services/global.service';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, OnInit, EventEmitter, Output, Inject, Input, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { LoginRequest } from 'app/models/ss-api/requests/login.request';
import { ErrorEventArgs } from 'app/models/event-args/global-error.event.args';


@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html'
})
export class LoginFormComponent implements OnInit {

    // events
    @Output('onBusyChanged') onBusyChanged = new EventEmitter<Boolean>();
    @Output('onAuthenticationFailed') onAuthenticationFailed = new EventEmitter<LoginResponse>();
    @Output('onTwoFactorRequired') onTwoFactorRequired = new EventEmitter<KeyValuePairArray<string, string>>();
    @Output('onAuthenticated') onAuthenticated = new EventEmitter<IBaseResponse<any>>();
    @Output('onLocked') onLocked = new EventEmitter<IBaseResponse<any>>();
    @Output('onError') onError = new EventEmitter<ErrorEventArgs>();
    @Output('onUnfinishedOrder') onUnfinishedOrder = new EventEmitter<string>();

    @ViewChild('Password', { static: true }) PasswordField;

    // form
    signinForm: UntypedFormGroup;
    DisableEmail: boolean = false;

    // private
    showTimeout: boolean = true;
    ShowError: boolean = false;
    ErrorMessage: string;

    constructor(private api: ssApiService, private gb: GlobalServices) {
    }


    ngOnInit() {

        let email = localStorage.getItem('email');

        if (email == null) {
            email = '';
        } else {
            this.DisableEmail = true;
            console.log(1111122222, this.PasswordField);
            this.PasswordField.nativeElement.focus();
        }

        this.signinForm = new UntypedFormGroup({
            'email': new UntypedFormControl(email, [Validators.required, Validators.email]),
            'password': new UntypedFormControl('', [Validators.required, Validators.minLength(1)])
        });
    }


    checkEmailValid(): boolean {

        if (!this.signinForm.get('email').touched)
            return true;

        return this.signinForm.get('email').valid;
    }

    checkPasswordValid(): boolean {

        if (!this.signinForm.get('password').touched)
            return true;

        return this.signinForm.get('password').valid;
    }

    private ResetSigninFormSubmitRequest(request: Subscription) {
        request.unsubscribe();
        this.showTimeout = false;
        this.onBusyChanged.emit(false);
    }

    async onSigninFormSubmit() {


        this.onBusyChanged.emit(true);

        let data = new LoginRequest();
        data.Username = this.signinForm.get('email').value;
        data.Password = this.signinForm.get('password').value;
        data.Checksum = 'SDFSJKFHWEK524746SFDHSKFHk!1ksdhfskldhfkls246424DDDfFaustoksdCaltabianoDDD!!!';

        this.signinForm.setValue['password'] = '';

        let request = this.api.Login(data)
            .subscribe(response => {
                this.ResetSigninFormSubmitRequest(request);

                if (!response.Result && response.Message == 'LOCKED') {
                    // locked
                    this.onLocked.emit(response);
                    return;
                } else if (!response.Result && response.Data != undefined && response.Data.UnfinishedOrderID != undefined) {
                    // unfinished order
                    // this.gb.SetGlobalsFromLoginResponse(response.Data);
                    this.onUnfinishedOrder.emit(response.Data.UnfinishedOrderID);
                    // this.onAuthenticated.emit(response);
                    return;
                } else if (!response.Result) {
                    // error
                    this.ShowError = true;
                    this.ErrorMessage = 'Invalid username or password.';
                    this.onAuthenticationFailed.emit(response.Data);
                    return;
                }


                let data = response.Data;
                if (!data.Authenticated && !data.TwoFactorRequired) {
                    // not authenticated
                    this.onAuthenticationFailed.emit(data);
                    return;
                }


                // we are authenticated
                this.gb.SetGlobalsFromLoginResponse(data);


                if (data.TwoFactorRequired) {
                    // twofactor required
                    this.onTwoFactorRequired.emit(data.TwoFactorOptions);
                    return;
                }

                this.onAuthenticated.emit(response);
            },


            (error: any) => {

                this.ResetSigninFormSubmitRequest(request);

                // console.log(data);
                this.onError.emit(new ErrorEventArgs('0', error.OriginalError, error.FriendlyMessage, error.FriendlyTitle));
            }
            );


        // set timeout
        this.showTimeout = true;

        setTimeout(() => {

            this.ResetSigninFormSubmitRequest(request);

            if (this.showTimeout)
                this.onError.emit(new ErrorEventArgs('0', 'timeout', 'Error connecting to server. Please try again later.', 'Timeout Error'));

        }, this.gb.HttpTimeout);

    }



}
